import { DateFormatter } from './dateFormatter';

export function dateToFormattedHours(date?: string) {
  const hoursAgo = date ? Math.floor((new Date().getTime() - new Date(date).getTime()) / (60 * 60 * 1000)) : null;
  let updatedLastOnline;

  if (hoursAgo === 0) {
    updatedLastOnline = `<1h ago`;
  } else if (hoursAgo && hoursAgo < 12) {
    updatedLastOnline = `${hoursAgo}h ago`;
  } else {
    updatedLastOnline = DateFormatter(date!);
  }

  return updatedLastOnline;
}
